export const resolveCommandBarAppearance = <T extends string>(
  key: string,
  appearance?: T
): T | 'primary' | 'subtle' =>
  appearance ??
  (key !== 'newFromTemplate' && /^(new|create|add)/i.test(key)
    ? 'primary'
    : 'subtle');
